import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export default function SelectionCard({
  option,
  isSelected,
  isLeafSelected,
  onClick,
  onSelectAgain,
  getProductIcon,
}) {
  return (
    <Paper
      onClick={onClick}
      sx={{
        width: '100%',
        maxWidth: 320,
        p: 2,
        height: '100%',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: '1px solid',
        borderColor: isSelected ? 'primary.main' : 'divider',
        backgroundColor: isSelected ? 'rgba(25, 118, 210, 0.08)' : 'background.paper',
        minWidth: 0,
        position: 'relative',
        '&:hover': {
          boxShadow: 5,
          borderColor: 'primary.main',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        {getProductIcon(option.value)}
        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            {option.label}
          </Typography>
          {option.subLabel ? (
            <Typography variant="caption" color="text.secondary">
              {option.subLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {option.description ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {option.description}
        </Typography>
      ) : null}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
        <Typography variant="caption" color="text.secondary">
          {option.options?.length ? `${option.options.length} choices` : 'Select'}
        </Typography>
        {option.options && option.options.length > 0 ? (
          <Typography variant="caption" color="primary.main">
            Next
          </Typography>
        ) : null}
      </Box>
      {isLeafSelected && onSelectAgain ? (
        <Button
          size="small"
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            onSelectAgain();
          }}
          sx={{ mt: 2, alignSelf: 'flex-start', textTransform: 'none' }}
        >
          Select Again
        </Button>
      ) : null}
      {isSelected ? (
        <Box sx={{ position: 'absolute', top: 12, right: 12, color: 'primary.main' }}>
          <CheckIcon fontSize="small" />
        </Box>
      ) : null}
    </Paper>
  );
}
